import { CheckBox, Form, NumberBox, SelectBox, TextArea, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, Label, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';

class FormFieldValidations extends Component {
    state = {
        validation: this.props.validation ?? { id: 0 },
    }

    set = updater => {
        updater(this.state.validation);
        this.forceUpdate();
    }

    render() {

        let va = this.state.validation;

        return (
            <Form rtlEnabled colCount={60} width='50rem' height='auto'>
                {/* 
                <SimpleItem colSpan={60}>
                    <div style={{ width: '100%', opacity: '50%', display: 'flex' }}>
                        ◈ اعتبار سنجی:
                    </div>
                </SimpleItem> 

                <EmptyItem colSpan={60} /> 
                */}

                <SimpleItem colSpan={30}>
                    <Label text='قالب کلی' />
                    <SelectBox rtlEnabled items={['ایمیل', 'کد ملی', 'شماره موبایل', 'عدد', 'عدد صحیح', 'سایر']}
                        value={va.template} onValueChanged={e => this.set(v => v.template = e.value)}
                    />
                </SimpleItem>

                <SimpleItem colSpan={30}>
                    <Label text='مقداردهی ضروری' />
                    <CheckBox rtlEnabled value={va.isNotNull === true} onValueChanged={e => this.set(v => v.isNotNull = e.value === true)}
                    />
                </SimpleItem>

                <SimpleItem colSpan={30}>
                    <Label text='حداقل' />
                    <NumberBox value={va.min} onValueChanged={e => this.set(v => v.min = e.value)} />
                </SimpleItem>

                <SimpleItem colSpan={30}>
                    <Label text='حداکثر' />
                    <NumberBox value={va.max} onValueChanged={e => this.set(v => v.max = e.value)} />
                </SimpleItem>

                <SimpleItem colSpan={60}>
                    <Label text='ریجکس' />
                    <TextBox rtlEnabled={false} className='mdh-left-align'
                        value={va.regEx} onValueChanged={e => this.set(v => v.regEx = e.value)} />
                </SimpleItem>

                <SimpleItem colSpan={60}>
                    <Label text='Url' />
                    <TextBox rtlEnabled={false} className='mdh-left-align' value={va.aoiUrl} onValueChanged={e => this.set(v => v.apiUrl = e.value)} />
                </SimpleItem>

                <SimpleItem colSpan={60}>
                    <Label text='عبارت جاواسکریپت' />
                    <TextArea rtlEnabled={false} minHeight='4rem' autoResizeEnabled className='mdh-left-align'
                        value={va.expressionJs} onValueChanged={e => this.set(v => v.expressionJs = e.value)}
                        placeholder='Make a js expression resulting the validity status (true or false). Use @{v} for field value, @{row} for row and @{table} for whole table.'
                    />
                </SimpleItem>

                <EmptyItem colSpan={60} />

                <ButtonItem colSpan={15} buttonOptions={{
                    text: 'قبول', icon: 'check', width: '90%', type: 'success',
                    onClick: () => this.props.onOk(va)
                }}
                />

                <ButtonItem colSpan={15} buttonOptions={{
                    text: 'رد', icon: 'close', width: '90%', type: 'danger',
                    onClick: () => this.props.onCancel()
                }} />

            </Form >

        );
    }
}

export default FormFieldValidations;